/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, rightChain: NonNullable<unknown>, rightMetric: NonNullable<unknown>, rightValue: NonNullable<unknown> }} Chain_Page_Compare_Stake_Or_Hashrate_Different_No_LeftInputs */



/**
* | output |
* | --- |
* | "{leftChain} has no data, while {rightChain} {rightMetric} is {rightValue}" |
*
* @param {Chain_Page_Compare_Stake_Or_Hashrate_Different_No_LeftInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_stake_or_hashrate_different_no_left = /** @type {((inputs: Chain_Page_Compare_Stake_Or_Hashrate_Different_No_LeftInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Stake_Or_Hashrate_Different_No_LeftInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} has no data, while ${i?.rightChain} ${i?.rightMetric} is ${i?.rightValue}`)
});